import { NavLink, useLocation } from "react-router-dom";

const LINKS = {
  author: [
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 2C8.67157 2 8 2.67157 8 3.5V4.5C8 5.32843 8.67157 6 9.5 6H14.5C15.3284 6 16 5.32843 16 4.5V3.5C16 2.67157 15.3284 2 14.5 2H9.5Z"
            fill="#29A261"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 4.03662C5.24209 4.10719 4.44798 4.30764 3.87868 4.87694C3 5.75562 3 7.16983 3 9.99826V15.9983C3 18.8267 3 20.2409 3.87868 21.1196C4.75736 21.9983 6.17157 21.9983 9 21.9983H15C17.8284 21.9983 19.2426 21.9983 20.1213 21.1196C21 20.2409 21 18.8267 21 15.9983V9.99826C21 7.16983 21 5.75562 20.1213 4.87694C19.552 4.30764 18.7579 4.10719 17.5 4.03662V4.5C17.5 6.15685 16.1569 7.5 14.5 7.5H9.5C7.84315 7.5 6.5 6.15685 6.5 4.5V4.03662ZM7 9.75C6.58579 9.75 6.25 10.0858 6.25 10.5C6.25 10.9142 6.58579 11.25 7 11.25H7.5C7.91421 11.25 8.25 10.9142 8.25 10.5C8.25 10.0858 7.91421 9.75 7.5 9.75H7ZM10.5 9.75C10.0858 9.75 9.75 10.0858 9.75 10.5C9.75 10.9142 10.0858 11.25 10.5 11.25H17C17.4142 11.25 17.75 10.9142 17.75 10.5C17.75 10.0858 17.4142 9.75 17 9.75H10.5ZM7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75H7.5C7.91421 14.75 8.25 14.4142 8.25 14C8.25 13.5858 7.91421 13.25 7.5 13.25H7ZM10.5 13.25C10.0858 13.25 9.75 13.5858 9.75 14C9.75 14.4142 10.0858 14.75 10.5 14.75H17C17.4142 14.75 17.75 14.4142 17.75 14C17.75 13.5858 17.4142 13.25 17 13.25H10.5ZM7 16.75C6.58579 16.75 6.25 17.0858 6.25 17.5C6.25 17.9142 6.58579 18.25 7 18.25H7.5C7.91421 18.25 8.25 17.9142 8.25 17.5C8.25 17.0858 7.91421 16.75 7.5 16.75H7ZM10.5 16.75C10.0858 16.75 9.75 17.0858 9.75 17.5C9.75 17.9142 10.0858 18.25 10.5 18.25H17C17.4142 18.25 17.75 17.9142 17.75 17.5C17.75 17.0858 17.4142 16.75 17 16.75H10.5Z"
            fill="#29A261"
          ></path>
        </svg>
      ),
      title: "Список всіх замовлень",
      link: "/",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Shape"
            d="M21 13C21.55 13 22 13.44 22 14L22 19C22 20.65 20.65 22 19 22L5 22C3.34 22 2 20.65 2 19L2 14C2 13.44 2.44 13 3 13L21 13ZM10 16C9.44 16 9 16.44 9 17C9 17.55 9.44 18 10 18L14 18C14.55 18 15 17.55 15 17C15 16.44 14.55 16 14 16L10 16Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          ></path>
          <path
            id="Shape"
            d="M2 5C2 3.34 3.34 2 5 2L19 2C20.65 2 22 3.34 22 5L22 10C22 10.55 21.55 11 21 11L3 11C2.44 11 2 10.55 2 10L2 5ZM10 5C9.44 5 9 5.44 9 6C9 6.55 9.44 7 10 7L14 7C14.55 7 15 6.55 15 6C15 5.44 14.55 5 14 5L10 5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          ></path>
        </svg>
      ),
      title: "Мої замовлення",
      link: "/my-orders",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M22 12C22 17.52 17.52 22 12 22C6.47 22 2 17.52 2 12C2 6.47 6.47 2 12 2C17.52 2 22 6.47 22 12ZM12 17.75C12.41 17.75 12.75 17.41 12.75 17L12.75 11C12.75 10.58 12.41 10.25 12 10.25C11.58 10.25 11.25 10.58 11.25 11L11.25 17C11.25 17.41 11.58 17.75 12 17.75ZM12 7C12.55 7 13 7.44 13 8C13 8.55 12.55 9 12 9C11.44 9 11 8.55 11 8C11 7.44 11.44 7 12 7Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          ></path>
        </svg>
      ),
      title: "Інструкції",
      link: "/instructions",
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 17C11.4477 17 11 17.4477 11 18V19H9C8.44772 19 8 19.4477 8 20C8 20.5523 8.44771 21 9 21H15C15.5523 21 16 20.5523 16 20C16 19.4477 15.5523 19 15 19H13V18C13 17.4477 12.5523 17 12 17Z"
            fill="white"
          />
          <path
            d="M7 5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10V5Z"
            fill="white"
          />
          <path
            d="M4 5C2.34315 5 1 6.34315 1 8V9C1 10.6569 2.34315 12 4 12C4.55228 12 5 11.5523 5 11C5 10.4477 4.55228 10 4 10C3.44772 10 3 9.55228 3 9V8C3 7.44772 3.44772 7 4 7C4.55228 7 5 6.55228 5 6C5 5.44772 4.55228 5 4 5Z"
            fill="white"
          />
          <path
            d="M20 5C21.6569 5 23 6.34315 23 8V9C23 10.6569 21.6569 12 20 12C19.4477 12 19 11.5523 19 11C19 10.4477 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V8C21 7.44772 20.5523 7 20 7C19.4477 7 19 6.55228 19 6C19 5.44772 19.4477 5 20 5Z"
            fill="white"
          />
        </svg>
      ),
      title: "Рейтинг",
      link: "/rating",
    },
  ],
  manager: [
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M2 5C2 4.05 2 3.58 2.29 3.29C2.58 3 3.05 3 4 3L20 3C20.94 3 21.41 3 21.7 3.29C22 3.58 22 4.05 22 5C22 5.94 22 6.41 21.7 6.7C21.41 7 20.94 7 20 7L4 7C3.05 7 2.58 7 2.29 6.7C2 6.41 2 5.94 2 5Z"
            fill="#ffffff"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Subtract"
            d="M20.06 8.49C20.2 8.5 20.35 8.5 20.5 8.49L20.5 12.99C20.5 16.77 20.5 18.65 19.32 19.82C18.15 20.99 16.27 20.99 12.5 20.99L11.5 20.99C7.72 20.99 5.84 20.99 4.67 19.82C3.5 18.65 3.5 16.77 3.5 12.99L3.5 8.49C3.64 8.5 3.79 8.5 3.93 8.49L20.06 8.49ZM15 12.19C15.3 12.46 15.33 12.94 15.05 13.24L11.48 17.24C11.34 17.4 11.14 17.5 10.92 17.5C10.71 17.5 10.51 17.4 10.36 17.24L8.94 15.64C8.66 15.34 8.69 14.86 9 14.59C9.3 14.31 9.78 14.34 10.05 14.65L10.92 15.62L13.94 12.25C14.21 11.94 14.69 11.91 15 12.19Z"
            fill="#ffffff"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "На оцінці",
      link: "/manager-rating",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M22.36 10.69C23.21 9.84 23.21 8.47 22.36 7.63C21.52 6.78 20.15 6.78 19.3 7.63L19.18 7.76C19.05 7.88 19 8.05 19.03 8.22C19.05 8.33 19.08 8.49 19.15 8.67C19.28 9.05 19.52 9.54 19.99 10C20.45 10.47 20.94 10.71 21.32 10.84C21.5 10.91 21.66 10.94 21.77 10.96C21.94 10.99 22.11 10.94 22.23 10.81L22.36 10.69ZM16.51 16.5C16.69 16.36 16.85 16.2 17.16 15.88L21.12 11.93C21.22 11.83 21.17 11.67 21.05 11.62C20.58 11.46 19.97 11.16 19.4 10.59C18.83 10.02 18.53 9.41 18.37 8.94C18.32 8.82 18.16 8.77 18.06 8.87L14.11 12.83C13.79 13.14 13.63 13.3 13.49 13.48C13.33 13.68 13.19 13.91 13.08 14.14C12.99 14.34 12.92 14.56 12.77 14.98L12.59 15.53L12.3 16.41L12.03 17.23C11.96 17.44 12.01 17.67 12.17 17.82C12.32 17.98 12.55 18.03 12.76 17.96L13.58 17.69L14.46 17.4L15.01 17.22C15.43 17.07 15.65 17 15.85 16.91C16.08 16.8 16.31 16.66 16.51 16.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
          <path
            id="Vector"
            d="M4.17 3.17C3 4.34 3 6.22 3 10L3 14C3 17.77 3 19.65 4.17 20.82C5.34 22 7.22 22 11 22L13 22C16.77 22 18.65 22 19.82 20.82C20.98 19.67 21 17.83 21 14.18L18.18 16.99C17.91 17.26 17.69 17.48 17.44 17.68C17.14 17.91 16.83 18.1 16.49 18.26C16.21 18.4 15.91 18.5 15.55 18.62L13.24 19.39C12.49 19.64 11.66 19.44 11.11 18.88C10.55 18.33 10.35 17.5 10.6 16.75L10.88 15.93L11.35 14.51L11.37 14.44C11.49 14.08 11.59 13.78 11.73 13.5C11.89 13.16 12.08 12.85 12.31 12.55C12.51 12.3 12.73 12.08 13 11.81L17 7.81L18.12 6.7L18.24 6.57C18.96 5.85 19.9 5.49 20.83 5.5C20.68 4.46 20.39 3.73 19.82 3.17C18.65 2 16.77 2 13 2L11 2C7.22 2 5.34 2 4.17 3.17ZM7.25 9C7.25 8.58 7.58 8.25 8 8.25L14.5 8.25C14.91 8.25 15.25 8.58 15.25 9C15.25 9.41 14.91 9.75 14.5 9.75L8 9.75C7.58 9.75 7.25 9.41 7.25 9ZM7.25 13C7.25 12.58 7.58 12.25 8 12.25L10.5 12.25C10.91 12.25 11.25 12.58 11.25 13C11.25 13.41 10.91 13.75 10.5 13.75L8 13.75C7.58 13.75 7.25 13.41 7.25 13ZM7.25 17C7.25 16.58 7.58 16.25 8 16.25L9.5 16.25C9.91 16.25 10.25 16.58 10.25 17C10.25 17.41 9.91 17.75 9.5 17.75L8 17.75C7.58 17.75 7.25 17.41 7.25 17Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "В роботі",
      link: "/manager-in-proccess",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M15.5 7.5C15.5 9.43 13.93 11 12 11C10.06 11 8.5 9.43 8.5 7.5C8.5 5.56 10.06 4 12 4C13.93 4 15.5 5.56 15.5 7.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Vector"
            d="M18 16.5C18 18.43 15.31 20 12 20C8.68 20 6 18.43 6 16.5C6 14.56 8.68 13 12 13C15.31 13 18 14.56 18 16.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Vector"
            d="M7.63 5.05C7.47 5.01 7.29 5 7.12 5C5.7 5 4.56 6.1 4.56 7.47C4.56 8.83 5.7 9.94 7.12 9.94C7.28 9.94 7.45 9.92 7.61 9.89C7.22 9.18 7 8.36 7 7.5C7 6.61 7.23 5.77 7.63 5.05ZM4.5 16.5C4.5 17.47 4.87 18.3 5.44 18.98C3.51 18.85 2 17.8 2 16.52C2 15.26 3.49 14.22 5.39 14.07C4.85 14.74 4.5 15.55 4.5 16.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
          <path
            id="Vector"
            d="M16.38 9.89C16.77 9.18 16.99 8.36 16.99 7.5C16.99 6.61 16.76 5.77 16.35 5.05C16.52 5.01 16.7 5 16.87 5C18.29 5 19.43 6.1 19.43 7.47C19.43 8.83 18.29 9.94 16.87 9.94C16.7 9.94 16.54 9.92 16.38 9.89ZM21.99 16.52C21.99 17.8 20.48 18.85 18.55 18.98C19.12 18.3 19.49 17.47 19.49 16.5C19.49 15.55 19.14 14.74 18.6 14.07C20.5 14.22 21.99 15.26 21.99 16.52Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "Автори",
      link: "/manager-authors",
    },
  ],
  owner: [
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M2 5C2 4.05 2 3.58 2.29 3.29C2.58 3 3.05 3 4 3L20 3C20.94 3 21.41 3 21.7 3.29C22 3.58 22 4.05 22 5C22 5.94 22 6.41 21.7 6.7C21.41 7 20.94 7 20 7L4 7C3.05 7 2.58 7 2.29 6.7C2 6.41 2 5.94 2 5Z"
            fill="#ffffff"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Subtract"
            d="M20.06 8.49C20.2 8.5 20.35 8.5 20.5 8.49L20.5 12.99C20.5 16.77 20.5 18.65 19.32 19.82C18.15 20.99 16.27 20.99 12.5 20.99L11.5 20.99C7.72 20.99 5.84 20.99 4.67 19.82C3.5 18.65 3.5 16.77 3.5 12.99L3.5 8.49C3.64 8.5 3.79 8.5 3.93 8.49L20.06 8.49ZM15 12.19C15.3 12.46 15.33 12.94 15.05 13.24L11.48 17.24C11.34 17.4 11.14 17.5 10.92 17.5C10.71 17.5 10.51 17.4 10.36 17.24L8.94 15.64C8.66 15.34 8.69 14.86 9 14.59C9.3 14.31 9.78 14.34 10.05 14.65L10.92 15.62L13.94 12.25C14.21 11.94 14.69 11.91 15 12.19Z"
            fill="#ffffff"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "На оцінці",
      link: "/owner-rating",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M22.36 10.69C23.21 9.84 23.21 8.47 22.36 7.63C21.52 6.78 20.15 6.78 19.3 7.63L19.18 7.76C19.05 7.88 19 8.05 19.03 8.22C19.05 8.33 19.08 8.49 19.15 8.67C19.28 9.05 19.52 9.54 19.99 10C20.45 10.47 20.94 10.71 21.32 10.84C21.5 10.91 21.66 10.94 21.77 10.96C21.94 10.99 22.11 10.94 22.23 10.81L22.36 10.69ZM16.51 16.5C16.69 16.36 16.85 16.2 17.16 15.88L21.12 11.93C21.22 11.83 21.17 11.67 21.05 11.62C20.58 11.46 19.97 11.16 19.4 10.59C18.83 10.02 18.53 9.41 18.37 8.94C18.32 8.82 18.16 8.77 18.06 8.87L14.11 12.83C13.79 13.14 13.63 13.3 13.49 13.48C13.33 13.68 13.19 13.91 13.08 14.14C12.99 14.34 12.92 14.56 12.77 14.98L12.59 15.53L12.3 16.41L12.03 17.23C11.96 17.44 12.01 17.67 12.17 17.82C12.32 17.98 12.55 18.03 12.76 17.96L13.58 17.69L14.46 17.4L15.01 17.22C15.43 17.07 15.65 17 15.85 16.91C16.08 16.8 16.31 16.66 16.51 16.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
          <path
            id="Vector"
            d="M4.17 3.17C3 4.34 3 6.22 3 10L3 14C3 17.77 3 19.65 4.17 20.82C5.34 22 7.22 22 11 22L13 22C16.77 22 18.65 22 19.82 20.82C20.98 19.67 21 17.83 21 14.18L18.18 16.99C17.91 17.26 17.69 17.48 17.44 17.68C17.14 17.91 16.83 18.1 16.49 18.26C16.21 18.4 15.91 18.5 15.55 18.62L13.24 19.39C12.49 19.64 11.66 19.44 11.11 18.88C10.55 18.33 10.35 17.5 10.6 16.75L10.88 15.93L11.35 14.51L11.37 14.44C11.49 14.08 11.59 13.78 11.73 13.5C11.89 13.16 12.08 12.85 12.31 12.55C12.51 12.3 12.73 12.08 13 11.81L17 7.81L18.12 6.7L18.24 6.57C18.96 5.85 19.9 5.49 20.83 5.5C20.68 4.46 20.39 3.73 19.82 3.17C18.65 2 16.77 2 13 2L11 2C7.22 2 5.34 2 4.17 3.17ZM7.25 9C7.25 8.58 7.58 8.25 8 8.25L14.5 8.25C14.91 8.25 15.25 8.58 15.25 9C15.25 9.41 14.91 9.75 14.5 9.75L8 9.75C7.58 9.75 7.25 9.41 7.25 9ZM7.25 13C7.25 12.58 7.58 12.25 8 12.25L10.5 12.25C10.91 12.25 11.25 12.58 11.25 13C11.25 13.41 10.91 13.75 10.5 13.75L8 13.75C7.58 13.75 7.25 13.41 7.25 13ZM7.25 17C7.25 16.58 7.58 16.25 8 16.25L9.5 16.25C9.91 16.25 10.25 16.58 10.25 17C10.25 17.41 9.91 17.75 9.5 17.75L8 17.75C7.58 17.75 7.25 17.41 7.25 17Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "В роботі",
      link: "/owner-in-proccess",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Vector"
            d="M15.5 7.5C15.5 9.43 13.93 11 12 11C10.06 11 8.5 9.43 8.5 7.5C8.5 5.56 10.06 4 12 4C13.93 4 15.5 5.56 15.5 7.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Vector"
            d="M18 16.5C18 18.43 15.31 20 12 20C8.68 20 6 18.43 6 16.5C6 14.56 8.68 13 12 13C15.31 13 18 14.56 18 16.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Vector"
            d="M7.63 5.05C7.47 5.01 7.29 5 7.12 5C5.7 5 4.56 6.1 4.56 7.47C4.56 8.83 5.7 9.94 7.12 9.94C7.28 9.94 7.45 9.92 7.61 9.89C7.22 9.18 7 8.36 7 7.5C7 6.61 7.23 5.77 7.63 5.05ZM4.5 16.5C4.5 17.47 4.87 18.3 5.44 18.98C3.51 18.85 2 17.8 2 16.52C2 15.26 3.49 14.22 5.39 14.07C4.85 14.74 4.5 15.55 4.5 16.5Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
          <path
            id="Vector"
            d="M16.38 9.89C16.77 9.18 16.99 8.36 16.99 7.5C16.99 6.61 16.76 5.77 16.35 5.05C16.52 5.01 16.7 5 16.87 5C18.29 5 19.43 6.1 19.43 7.47C19.43 8.83 18.29 9.94 16.87 9.94C16.7 9.94 16.54 9.92 16.38 9.89ZM21.99 16.52C21.99 17.8 20.48 18.85 18.55 18.98C19.12 18.3 19.49 17.47 19.49 16.5C19.49 15.55 19.14 14.74 18.6 14.07C20.5 14.22 21.99 15.26 21.99 16.52Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "Автори",
      link: "/owner-authors",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Shape"
            d="M4 3C2.34 3 1 4.34 1 6L1 8L23 8L23 6C23 4.34 21.65 3 20 3L4 3ZM23 10L1 10L1 18C1 19.65 2.34 21 4 21L20 21C21.65 21 23 19.65 23 18L23 10ZM8 15.5C8 16.32 7.32 17 6.5 17C5.67 17 5 16.32 5 15.5C5 14.67 5.67 14 6.5 14C7.32 14 8 14.67 8 15.5ZM11.5 17C12.32 17 13 16.32 13 15.5C13 14.67 12.32 14 11.5 14C10.67 14 10 14.67 10 15.5C10 16.32 10.67 17 11.5 17Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "Виплати",
      link: "/owner-payments",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Shape"
            d="M7 2C5.34 2 4 3.34 4 5L4 19C4 20.65 5.34 22 7 22L17 22C18.65 22 20 20.65 20 19L20 5C20 3.34 18.65 2 17 2L7 2ZM7 6C7 5.44 7.44 5 8 5L16 5C16.55 5 17 5.44 17 6C17 6.55 16.55 7 16 7L8 7C7.44 7 7 6.55 7 6ZM9 10C9 10.55 8.55 11 8 11C7.44 11 7 10.55 7 10C7 9.44 7.44 9 8 9C8.55 9 9 9.44 9 10ZM12 11C12.55 11 13 10.55 13 10C13 9.44 12.55 9 12 9C11.44 9 11 9.44 11 10C11 10.55 11.44 11 12 11ZM16 11C16.55 11 17 10.55 17 10C17 9.44 16.55 9 16 9C15.44 9 15 9.44 15 10C15 10.55 15.44 11 16 11ZM8 15C8.55 15 9 14.55 9 14C9 13.44 8.55 13 8 13C7.44 13 7 13.44 7 14C7 14.55 7.44 15 8 15ZM12 15C12.55 15 13 14.55 13 14C13 13.44 12.55 13 12 13C11.44 13 11 13.44 11 14C11 14.55 11.44 15 12 15ZM16 15C16.55 15 17 14.55 17 14C17 13.44 16.55 13 16 13C15.44 13 15 13.44 15 14C15 14.55 15.44 15 16 15ZM8 19C8.55 19 9 18.55 9 18C9 17.44 8.55 17 8 17C7.44 17 7 17.44 7 18C7 18.55 7.44 19 8 19ZM12 19C12.55 19 13 18.55 13 18C13 17.44 12.55 17 12 17C11.44 17 11 17.44 11 18C11 18.55 11.44 19 12 19ZM16 19C16.55 19 17 18.55 17 18C17 17.44 16.55 17 16 17C15.44 17 15 17.44 15 18C15 18.55 15.44 19 16 19Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="evenodd"
          />
        </svg>
      ),
      title: "Дохід",
      link: "/owner-income",
    },
    {
      icon: (
        <svg
          width="24.000000"
          height="24.000000"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <path
            id="Shape"
            d="M18.78 12.39L14.97 10.48C14.58 10.29 14.16 10.64 14.26 11.05L14.94 13.77C14.97 13.91 15.07 14.03 15.2 14.1L17.38 15.19C18.23 15.61 19.26 15.19 19.57 14.28C19.81 13.54 19.48 12.74 18.78 12.39Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Shape"
            d="M6.81 8.75C6.92 8.31 7.32 8 7.78 8L10.21 8C10.67 8 11.07 8.31 11.18 8.75L13.84 19.37C13.93 19.75 13.8 20.15 13.49 20.4L9.62 23.5C9.25 23.79 8.74 23.79 8.37 23.5L4.5 20.4C4.19 20.15 4.06 19.75 4.15 19.37L6.81 8.75Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
          <path
            id="Shape"
            d="M5.72 0.55C5.89 0.21 6.23 0 6.61 0L11.38 0C11.76 0 12.1 0.21 12.27 0.55L12.77 1.55C12.91 1.83 12.91 2.16 12.77 2.44L11.27 5.44C11.1 5.78 10.76 6 10.38 6L7.61 6C7.23 6 6.89 5.78 6.72 5.44L5.22 2.44C5.08 2.16 5.08 1.83 5.22 1.55L5.72 0.55Z"
            fill="#FFFFFF"
            fillOpacity="1.000000"
            fillRule="nonzero"
          />
        </svg>
      ),
      title: "Персонал",
      link: "/owner-personal",
    },
  ],
};

export const NavLinks = () => {
  const { pathname } = useLocation();

  return (
    <ul className="main-menu">
      {LINKS[
        pathname?.includes("manager")
          ? "manager"
          : pathname?.includes("owner")
          ? "owner"
          : "author"
      ]?.map(({ icon, title, link }, i) => (
        <li className="main-menu__item">
          <NavLink
            to={link}
            key={i}
            className="main-menu__link"
            activeclassname="active"
          >
            <span className="icon">{icon}</span>
            <span className="text">{title}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};
